<script>
  import { onMount, onDestroy } from 'svelte'
  import Login from './Login.svelte'
  import Form from './Form.svelte'
  import Intro from './Intro.svelte'
  import Cookies from 'js-cookie'
  import gsap from 'gsap'
  import ScrollTrigger from 'gsap/ScrollTrigger'
  import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
  import SplitText from 'gsap/SplitText'
  import LinearPath from './LinearPath.svelte'
  import DigitalPath from './DigitalPath.svelte'
  import Header from './components/Header.svelte'
  import { GoogleAnalytics, ga } from '@beyonk/svelte-google-analytics'
  import { scrollPercent } from './TrackScrollPct'
  import { emailStore } from './store'

  gsap.registerPlugin(ScrollTrigger, SplitText, DrawSVGPlugin)
  window.ScrollTrigger = ScrollTrigger

  const { gaTagId, production, usePassword } = ENVIRONMENT
  const unsubscribeToProgress = scrollPercent.subscribe((pct) => {
    if (pct > 0) ga.addEvent('scroll', { percent: pct })
  })

  let formComplete = Cookies.get('formComplete') === 'true',
    loggedIn = usePassword === false,
    path = production ? 'intro' : 'intro',
    fontsLoaded = false,
    isPathMounting = false,
    refreshTimeout

  $: if (path) {
    isPathMounting = true
  }

  onMount(() => {
    document.fonts.ready.then(() => {
      fontsLoaded = true
    })
    window.ga = ga
    document.addEventListener('accordion-change', onAccordionChange)
  })

  onDestroy(() => {
    document.removeEventListener('accordion-change', onAccordionChange)
    unsubscribeToProgress()
  })

  function onAccordionChange(event) {
    clearTimeout(refreshTimeout)
    refreshTimeout = setTimeout(() => {
      ScrollTrigger.refresh(true)
    }, 100)
  }

  function onLoggedIn(event) {
    loggedIn = event.detail
  }

  function onFormComplete(event) {
    window.scrollTo(0, 0)
    Cookies.set('formComplete', 'true', { expires: 365 })
    formComplete = true
    if (event.detail.email) emailStore.set(event.detail.email)
    try {
      ga.addEvent('form_submit_complete', {
        formId: event.detail.formId,
      })
    } catch (e2) {
      console.log(e2)
    }
  }

  function onChoosePathFromIntro(event) {
    onChoosePath(event)
    try {
      const eventName = 'choose_path_' + event.detail.name
      ga.addEvent(eventName, {})
    } catch (e) {
      console.log(e)
    }
  }
  function onChoosePath(event) {
    window.scrollTo(0, 0)
    path = event.detail.name
  }

  function onRestart(event) {
    onChoosePath(event)
    scrollPercent.set(0)
    try {
      ga.addEvent('restart', {
        button: 'restart',
      })
    } catch (e) {
      console.log(e)
    }
  }

  function onChoosePathFromHeader(event) {
    if (event.detail.name !== 'intro') {
      try {
        ga.addEvent('change_path_' + event.detail.name, {})
      } catch (e) {
        console.log(e)
      }
    } else if (path !== 'intro') {
      try {
        ga.addEvent('restart', {
          button: 'logo',
        })
      } catch (e) {
        console.log(e)
      }
    }
    onChoosePath(event)
  }

  function onPathMounted(event) {
    isPathMounting = false
  }

  function onResize() {
    clearTimeout(refreshTimeout)
    refreshTimeout = setTimeout(refreshScrollTrigger, 500)
  }

  function refreshScrollTrigger() {
    ScrollTrigger.refresh()
  }
</script>

<svelte:window on:resize={onResize} />
<GoogleAnalytics properties={[gaTagId]} />
<div id="App">
  {#if fontsLoaded}
    <Header {path} {isPathMounting} on:path={onChoosePathFromHeader} />
    <main>
      {#if loggedIn}
        {#if !formComplete}
          <Form on:formComplete={onFormComplete} />
        {:else if path === 'intro'}
          <Intro on:path={onChoosePathFromIntro} on:mounted={onPathMounted} />
        {:else if path === 'linear'}
          <LinearPath on:path={onRestart} on:mounted={onPathMounted} />
        {:else if path === 'digital'}
          <DigitalPath on:path={onRestart} on:mounted={onPathMounted} />
        {/if}
      {:else}
        <Login on:loggedIn={onLoggedIn} />
      {/if}
    </main>
  {/if}
</div>

<style>
  main {
    padding: 140px 0 0;
  }
</style>
